import TiptapBulletList from '@tiptap/extension-bullet-list';
import TiptapOrderedList from '@tiptap/extension-ordered-list';

export const BulletList = TiptapBulletList.extend({
  addOptions() {
    const parentOptions = this.parent?.() ?? {
      itemTypeName: 'listItem',
      keepMarks: false,
      keepAttributes: false,
      HTMLAttributes: {},
    };
    return {
      ...parentOptions,
      HTMLAttributes: {
        ...parentOptions.HTMLAttributes,
        class: 'editor-bullet-list',
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    const parentClass = this.options.HTMLAttributes?.class ?? '';
    const extraClass = (HTMLAttributes as Record<string, unknown>)?.class ?? '';
    const mergedClass = [parentClass, extraClass].filter(Boolean).join(' ');

    return [
      'ul',
      { ...this.options.HTMLAttributes, ...HTMLAttributes, class: mergedClass },
      0,
    ];
  },
});

export const OrderedList = TiptapOrderedList.extend({
  addOptions() {
    const parentOptions = this.parent?.() ?? {
      itemTypeName: 'listItem',
      keepMarks: false,
      keepAttributes: false,
      HTMLAttributes: {},
    };
    return {
      ...parentOptions,
      HTMLAttributes: {
        ...parentOptions.HTMLAttributes,
        class: 'editor-ordered-list',
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    const parentClass = this.options.HTMLAttributes?.class ?? '';
    const extraClass = (HTMLAttributes as Record<string, unknown>)?.class ?? '';
    const mergedClass = [parentClass, extraClass].filter(Boolean).join(' ');

    return [
      'ol',
      { ...this.options.HTMLAttributes, ...HTMLAttributes, class: mergedClass },
      0,
    ];
  },
});
